/**
 * Subscription Cart Fix
 * サブスク専用商品が単品でカートに追加された場合、
 * 自動的にサブスク（selling_plan付き）に変換する
 */

(function () {
  'use strict';

  const SubscriptionCartFix = {
    processingKey: 'subscription_cart_fix_processing',

    async init() {
      // カートページのみ実行
      if (!this.isCartPage()) return;

      // 二重実行防止
      if (sessionStorage.getItem(this.processingKey)) {
        sessionStorage.removeItem(this.processingKey);
        return;
      }

      await this.checkAndFixCart();
    },

    isCartPage() {
      return window.location.pathname === '/cart';
    },

    async getCart() {
      const res = await fetch('/cart.js');
      if (!res.ok) throw new Error('カート取得失敗');
      return res.json();
    },

    async getProduct(handle) {
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) throw new Error(`商品取得失敗: ${handle}`);
      return res.json();
    },

    async removeItem(itemKey) {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: itemKey, quantity: 0 }),
      });
      if (!res.ok) throw new Error('カートアイテム削除失敗');
      return res.json();
    },

    async addItemWithSellingPlan(variantId, quantity, sellingPlanId) {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity,
          selling_plan: sellingPlanId,
        }),
      });
      if (!res.ok) throw new Error('サブスクアイテム追加失敗');
      return res.json();
    },

    showProcessingUI() {
      // 処理中オーバーレイを表示
      const overlay = document.createElement('div');
      overlay.id = 'subscription-fix-overlay';
      overlay.innerHTML = `
        <div style="
          position: fixed;
          top: 0; left: 0;
          width: 100%; height: 100%;
          background: rgba(255,255,255,0.85);
          z-index: 9999;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          font-family: sans-serif;
        ">
          <div style="
            width: 40px; height: 40px;
            border: 3px solid #ddd;
            border-top-color: #333;
            border-radius: 50%;
            animation: spin 0.8s linear infinite;
            margin-bottom: 16px;
          "></div>
          <p style="color: #333; font-size: 14px;">定期購入プランを設定中...</p>
        </div>
        <style>
          @keyframes spin { to { transform: rotate(360deg); } }
        </style>
      `;
      document.body.appendChild(overlay);
    },

    hideProcessingUI() {
      const overlay = document.getElementById('subscription-fix-overlay');
      if (overlay) overlay.remove();
    },

    async checkAndFixCart() {
      try {
        const cart = await this.getCart();
        if (!cart.items || cart.items.length === 0) return;

        const itemsToFix = [];

        for (const item of cart.items) {
          // 既にselling_planが付いている場合はスキップ
          if (item.selling_plan_allocation) continue;

          const product = await this.getProduct(item.handle);

          // requires_selling_plan が true、
          // またはselling_plan_groupsが存在する商品のみ対象
          const hasSellingPlans =
            product.requires_selling_plan === true ||
            (product.selling_plan_groups && product.selling_plan_groups.length > 0);

          if (!hasSellingPlans) continue;

          // 最初のselling_planを取得
          const sellingPlanId =
            product.selling_plan_groups?.[0]?.selling_plans?.[0]?.id;

          if (!sellingPlanId) continue;

          itemsToFix.push({
            key: item.key,
            variantId: item.variant_id,
            quantity: item.quantity,
            sellingPlanId: sellingPlanId,
            title: item.title,
          });
        }

        // 修正対象がなければ終了
        if (itemsToFix.length === 0) return;

        this.showProcessingUI();

        for (const item of itemsToFix) {
          console.log(`[SubscriptionFix] 変換中: ${item.title}`);

          // カートから削除
          await this.removeItem(item.key);

          // selling_plan付きで再追加
          await this.addItemWithSellingPlan(
            item.variantId,
            item.quantity,
            item.sellingPlanId
          );
        }

        // リロード（二重処理防止フラグを立ててから）
        sessionStorage.setItem(this.processingKey, '1');
        window.location.reload();

      } catch (error) {
        this.hideProcessingUI();
        console.error('[SubscriptionFix] エラー:', error);
      }
    },
  };

  // DOM読み込み後に実行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => SubscriptionCartFix.init());
  } else {
    SubscriptionCartFix.init();
  }
})();
